import { api } from './_client';
import type {
  UserProfileFull,
  ProfileUpdateRequest,
  ProfilePictureResponse,
  CertificationResponse,
} from '../../types/api';

export const profilesApi = {
  // Get user profile
  async getProfile(userId: string): Promise<UserProfileFull> {
    const response = await api.get<UserProfileFull>(`/profiles/${userId}`);
    return response.data;
  },

  // Update user profile
  async updateProfile(userId: string, data: ProfileUpdateRequest): Promise<UserProfileFull> {
    const response = await api.put<UserProfileFull>(`/profiles/${userId}`, data);
    return response.data;
  },

  // Upload profile picture
  async uploadProfilePicture(userId: string, file: File): Promise<ProfilePictureResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post<ProfilePictureResponse>(
      `/profiles/${userId}/picture`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000, // 1 minute for image upload
      }
    );
    return response.data;
  },

  // Delete profile picture
  async deleteProfilePicture(userId: string): Promise<ProfilePictureResponse> {
    const response = await api.delete<ProfilePictureResponse>(`/profiles/${userId}/picture`);
    return response.data;
  },

  // Add certification to profile
  async addCertification(
    userId: string,
    name: string,
    expiryDate?: string,
    document?: File
  ): Promise<CertificationResponse> {
    const formData = new FormData();
    formData.append('name', name);
    if (expiryDate) {
      formData.append('expiry_date', expiryDate);
    }
    if (document) {
      formData.append('document', document);
    }

    const response = await api.post<CertificationResponse>(
      `/profiles/${userId}/certifications`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000, // 1 minute for document upload
      }
    );
    return response.data;
  },

  // Remove certification from profile
  async removeCertification(
    userId: string,
    certificationIndex: number
  ): Promise<CertificationResponse> {
    const response = await api.delete<CertificationResponse>(
      `/profiles/${userId}/certifications/${certificationIndex}`
    );
    return response.data;
  },
};
